import React, { useState } from 'react';
import './AddChalisaForm.css';

const AddChalisaForm = ({ onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    image_url: '',
    content: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name.trim()) {
      alert('Please enter a chalisa name');
      return;
    }

    setLoading(true);
    try {
      await onSave(formData);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="add-chalisa-form">
      <div className="form-container">
        <div className="form-header">
          <h1 className="form-title">
            ➕ Add New Chalisa
          </h1>
          <button
            onClick={onClose}
            className="back-button"
          >
            ← Back
          </button>
        </div>

        <form onSubmit={handleSubmit} className="chalisa-form">
          <div className="form-group">
            <label htmlFor="name" className="form-label">
              Chalisa Name <span className="required">*</span>
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="form-input"
              placeholder="Enter chalisa name"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="description" className="form-label">
              Description
            </label>
            <input
              type="text"
              id="description"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              className="form-input"
              placeholder="Enter chalisa description"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="image_url" className="form-label">
              Image URL
            </label>
            <input
              type="url"
              id="image_url"
              name="image_url"
              value={formData.image_url}
              onChange={handleInputChange}
              className="form-input"
              placeholder="Enter image URL (optional)"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="content" className="form-label">
              Chalisa Content
            </label>
            <textarea
              id="content"
              name="content"
              value={formData.content}
              onChange={handleInputChange}
              className="form-textarea"
              placeholder="Enter chalisa content (verses/text)"
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`submit-button ${loading ? 'loading' : ''}`}
          >
            {loading ? '⏳ Creating Chalisa...' : '✅ Create Chalisa'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddChalisaForm;